module.exports = __webpack_public_path__ + "static/media/Longreach.ed8989a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Longreach.jpg
// module id = 637
// module chunks = 0